<!-- 核心产品 -->
<template>
  <div class="product">
    <headerImg
      headerImgText
      :imgSrc="require('../../assets/product/pruductHeader.jpg')"
    ></headerImg>
    <div class="product-main">
      <div class="product-select">
        <el-row class="tac">
          <el-col :span="12">
            <el-menu
              :default-active="defleteIndex"
              class="el-menu-vertical-demo"
              :unique-opened="true"
              @open="handleOpen"
              @close="handleClose"
              @select="handSelect"
            >
              <el-submenu index="6">
                <template slot="title">
                  <span>200万/400万/500万摄像机模组</span>
                </template>
                <el-menu-item index="6-1">晶视智能</el-menu-item>
                <el-menu-item index="6-3">华为海思</el-menu-item>
                <el-menu-item index="6-2">厦门星宸</el-menu-item>
              </el-submenu>
              <el-submenu index="1">
                <template slot="title">
                  <span>智能摄像机模组</span>
                </template>
                <el-menu-item index="1-1">海思CV500/DV300人脸抓拍模组</el-menu-item>
                <el-menu-item index="1-2">海思CV500/DV300人脸识别模组</el-menu-item>
                <el-menu-item index="1-3">海思DV300机非人模组</el-menu-item>
                <el-menu-item index="1-4">晶视CV1821电动车检测模组</el-menu-item>
              </el-submenu>
              <el-submenu index="5">
                <template slot="title">
                  <span>机芯系列</span>
                </template>
                <el-menu-item index="5-1">晶视400万机芯</el-menu-item>
                <el-menu-item index="5-2">晶视500万机芯</el-menu-item>
              </el-submenu>
              <el-submenu index="3">
                <template slot="title">
                  <span>智能摄像机整机</span>
                </template>
                <!-- <el-menu-item index="3-5">智能考勤摄像机</el-menu-item> -->
                <el-menu-item index="3-1">民用消费类</el-menu-item>
                <el-menu-item index="3-2">专业安防类</el-menu-item>
                <el-menu-item index="3-3">人车结构化</el-menu-item>
                <el-menu-item index="3-5">人脸识别热成像体温筛查摄像机</el-menu-item>
                <el-menu-item index="3-4">USB摄像机</el-menu-item>
              </el-submenu>

              <el-submenu index="4">
                <template slot="title">
                  <span>海思方案门禁机整机</span>
                </template>
                <el-menu-item index="4-1">8寸高端行业双目测温门禁一体机</el-menu-item>
                <el-menu-item index="4-6">8寸高端行业双目门禁机</el-menu-item>
                <el-menu-item index="4-2">7寸单目人脸识别门禁</el-menu-item>
                <el-menu-item index="4-3">7寸双目人脸识别门禁</el-menu-item>
                <el-menu-item index="4-7">8寸双目人脸识别门禁</el-menu-item>
                <el-menu-item index="4-4">7寸经济型单目测温门禁</el-menu-item>
                <el-menu-item index="4-5">7寸经济型双目测温门禁</el-menu-item>
                <el-menu-item index="4-8">8寸经济型双目测温门禁</el-menu-item>
              </el-submenu>
              <el-submenu index="2">
                <template slot="title">
                  <span>安卓方案门禁机整机</span>
                </template>

                <el-menu-item index="2-1">6100系列</el-menu-item>
                <el-menu-item index="2-2">D200系列</el-menu-item>
                <el-menu-item index="2-4">M200系列</el-menu-item>
                <el-menu-item index="2-3">TOF门禁机整机</el-menu-item>
              </el-submenu>

            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div class="product-list">
        <productList ref="child"></productList>
      </div>
    </div>
  </div>
</template>

<script>
import headerImg from "../../components/headerImg";
import productList from "./ProductComponemt/productList";

export default {
  data() {
    return {
      defleteIndex: this.$route.params.index,
    };
  },

  components: {
    headerImg,
    productList,
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handSelect(index) {
      this.$refs.child.changeView(index);
    },
  },
};
</script>
<style scoped>
.el-col-12 {
  width: 100%;
}
.product {
  padding-bottom: 100px;
  background: #eeeeee;
}
.product-select {
  width: 40%;
}
.product-main {
  padding: 5% 15% 0 20%;
  display: flex;
}
.product-list {
  width: 100%;
  margin: 0 0 0 1.5%;
}
</style>